export enum FullCalendarViewEnum {
  DayGridMonth = 'dayGridMonth',
  ListWeek = 'listWeek',
  TimeGridWeek = 'timeGridWeek',
  TimeGridDay = 'timeGridDay',
}
